module.exports = __webpack_public_path__ + "static/img/drilling04.2f681d69.png";